var app = {
	header: {
		build: "Derleme",
		closeButton: "Kapat",
		copyrightLabel: "Telif Hakkı",
		helpLabel: "Yardım",
		legalNoticeLabel: "Yasal Uyarı",
		logoutButton: "Çıkış Yap",
		menuLabel: "Menü",
		module: "Modül",
		noUserDataLabel: "Kullanıcı verisi mevcut değil",
		notificationsLabel: "Bildirimler",
		privacyPolicyLabel: "Gizlilik Politikası",
		serviceAppLabel: "Servis Uygulaması",
		settingsLabel: "Ayarlar",
		shopLabel: "Mağaza",
		smartFactorySuiteLabel: "Akıllı-Fabrika Paketi",
		softwareInformation: "Yazılım Bilgisi",
		userLabel: "Profil",
		userProfileLinkText: "Kullanıcı Profili",
		version: "Versiyon"
	}
};
var contentLoadingError = "İçerik yüklenemedi";
var dashboard = {
	cancel: {
		button: "İptal"
	},
	edit: {
		button: "Düzenle"
	},
	reset: {
		button: "Sıfırla"
	},
	save: {
		button: "Kaydet"
	},
	share: {
		button: "Paylaş"
	}
};
var filter = {
	clear: "Filtreleri sıfırla",
	clearAll: "Tüm filtreleri sıfırla"
};
var locationMap = {
	locationLink: {
		label: "Konuma Git"
	}
};
var machineDiscontinuation = {
	linkText: "Daha fazla bilgi edin"
};
var notifications = {
	button: {
		loadMore: "Daha fazla yükle"
	},
	date: {
		lastMonth: "Geçen ay",
		lastWeek: "Geçen hafta",
		older: "Daha eski",
		thisMonth: "Bu ay",
		thisWeek: "Bu hafta",
		today: "Bugün",
		yesterday: "Dün"
	},
	error: {
		general: "Şu anda bildirimler görüntülenemiyor. Lütfen daha sonra tekrar deneyin.",
		unauthorized: "Bildirimleri görmek için lütfen giriş yapın"
	},
	info: {
		activateSettings: "Bildirimleri almak için lütfen ayarlarda etkinleştirin",
		noNotification: "Şu anda sizin için hiç mesaj yok."
	},
	title: "Bildirimler"
};
var results = {
	counter: {
		label: "Sonuç"
	}
};
var scrollToTop = {
	label: "Üste Kaydır"
};
var slider = {
	nextButton: {
		label: "Sonraki Slayt"
	},
	paginationBullet: {
		label: "Slayt"
	},
	prevButton: {
		label: "Önceki Slayt"
	}
};
var sorting = {
	ascending: "Artan",
	descending: "Azalan"
};
var userAccount = {
	address: {
		label: "Posta adresi"
	},
	email: {
		label: "E-posta"
	},
	language: {
		label: "Dil",
		locale: "Yerel",
		select: "Dil seç",
		settings: "Dil ayarları"
	},
	loggedOut: {
		message: "Giriş yapılmamış"
	},
	login: {
		button: "Giriş yap"
	},
	name: {
		label: "İsim"
	},
	phone: {
		label: "Telefon"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "Makineleri filtrele",
			label: "Makineler",
			option: {
				all: "Tüm Makineler"
			},
			select: "Makine seç"
		},
		period: {
			label: "Dönem",
			option: {
				currentMonth: "Bu ay",
				currentWeek: "Bu hafta",
				lastMonth: "Geçen ay",
				lastWeek: "Geçen hafta",
				today: "Bugün",
				yesterday: "Dün"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "Widget'larım"
	},
	noDescriptionAvailable: "Açıklama mevcut değil.",
	widget: {
		SampleMyMachines: {
			title: "Makinelerim"
		},
		SampleMyServiceCalls: {
			title: "Servis Çağrıları"
		},
		SampleMyTrackingList: {
			title: "Takip Listesi"
		},
		SampleMyUserAccount: {
			title: "Profilim"
		},
		SampleOperationalStatesChart: {
			title: "Operasyonel Durumlar"
		},
		SampleWidgetFilter: {
			title: "Filtre Ayarları"
		},
		SampleWorkloadBalanceChart: {
			title: "İş Yükü Dengesi"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	filter: filter,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, filter, locationMap, machineDiscontinuation, notifications, results, scrollToTop, slider, sorting, userAccount, widget, widgetRegistry };
